import { render, staticRenderFns } from "./providers.page.vue?vue&type=template&id=2dca8ace&"
import script from "./providers.page.vue?vue&type=script&lang=ts&"
export * from "./providers.page.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports